<template>
  <div class="index">
    <div class="Imgbg">
      <!-- 背景图上的内容 -->
      <div class="w1200 headbox">
        <div class="kuang"> <img :src="companyData.o_homeUrl|toimg" /></div>
        <div class="name">{{companyData.o_name}}</div>
        <div class="info">
          <span v-for="(x,i) in topInfo" :key="i">{{x}}</span>
        </div>
      </div>
    </div>
    <!-- 上部数据，导航栏以上 -->
    <div class="w1200 nav">
      <detailNav :disabled="!companyData.id" @navChangeHandler="navChangeHandler"></detailNav>
    </div>
    <!-- 中部数据，导航栏以下 -->
    <div class="w1200 dataListBox flex">
      <div class="left">
        <div class="datalist" v-show="routeType!='companyhome'">
          <p class="title" v-show="routeType!='companyhome'">{{mapList[type]}}</p>
          <!-- 除去公司首页，招聘，评价 -->
          <ul class="dataul" v-show="routeType!='companyhome'&&routeType!='zhaopin'&&routeType!='pingjia'">
            <li class="datali" v-for="(x1,i1) in tableData" :key="i1" @click="clickData(x1)">
              <img v-if="x1.imgUrl == ''" :src="require('@/assets/logo.png')"  />
              <img v-else :src="x1.imgUrl|toimg" />
              <div class="datainfo">
                <p class="dataname">{{x1.name}}</p>
                <div class="info">
                  <span v-for="(x2,i2) in datainfo" :key="i2" class="infospan">{{x2.title}}：{{x2.prefix}}{{x1[x2.val]}}{{x2.suffix}}</span>
                </div>
              </div>
            </li>
          </ul>
          <!-- 招聘 -->
          <ul class="zhaopin" v-show="routeType==='zhaopin'">
            <li class="zpList" v-for="(x1,i1) in tableData" :key="i1" @click="clickData(x1)">
              <p class="listTitle"><span class="jobname">{{x1.jobName}}</span><span class="money">{{x1.salary}}</span></p>
              <div class="listinfo">
                <div class="infodata">
                  <div class="infoleft" v-for="(x2,i2) in jobLeftinfo" :key="i2">
                    <span class="span1">{{x2.title}}:</span>
                    <span class="span2">{{x1[x2.shuxing]}}</span>
                  </div>
                </div>
                <div class="infodata">
                  <div class="inforight" v-for="(x2,i2) in jobRightinfo" :key="i2">
                    <span class="span3">{{x1[x2.shuxing]}}{{x2.suffix}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <!-- 评价 -->
          <div class="pingjia" v-show="routeType==='pingjia'">
            <div class="btnbox">
              <el-button type="danger" plain 
                v-for="(x,i) in pingjiaBtnArr" :key="i"
                :class="{'commentBtn':i===scoreIndex}"
                @click="fifterComment(i)">{{x.text}}</el-button>
            </div>
            <div class="databox">
              <p v-if="commentData.length===0">暂无评论数据</p>
              <div v-else>
                <el-table :data="commentData" style="width: 100%">
                  <el-table-column v-for="(x,i) in commentInfo" :key="i" :label="x.label" :prop="x.val"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <!-- 页码 -->
          <paging :pagesData="pageData" @set_page_number="pageChange"></paging>
        </div>
        <comments v-show="routeType==='pingjia'" :targetId="companyData.id" type="企业" :commentNum="pageData.total"></comments>

        <!-- 企业首页 -->
        <div class="companyhome" v-show="routeType==='companyhome'">
          <!-- 简介 -->
          <div class="companyIntroduce">
            <p class="introduceTitle">
              <span 
                v-for="(x,i) in setCompany.companyHomeTitleArr" :key="i"
                :class="{'introduceActive':setCompany.introduceTitleActive===x.active}"  
                @click="clickIntroduce(i)">{{x.text}}</span>
            </p>
            <div class="introduceText">
              <span v-show="setCompany.introduceTitleActive===0">{{companyData.o_description}}</span>
              <video v-show="setCompany.introduceTitleActive===1" :src="companyData.o_videoUrl" controls></video>
            </div>
          </div>
          <!-- 基本信息 -->
          <div class="basicInfo">
            <p class="title">基本信息</p>
            <div class="infoBox">
              <span class="box" v-for="(x,i) in setCompany.basicInfo" :key="i">
                {{x.title}}
                <span v-if="x.icon" class="address">
                  <i class="iconfont">{{x.icon}}</i> {{x.val}}
                </span>
                <span v-else>{{x.val}}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="otherJob">
          <div class="topbox">
            <span>该公司的其他职位</span>
            <span class="more">更多</span>
          </div>
          <ul class="otherul">
            <li v-for="(x1,i1) in otherJob" :key="i1" @click="clickData2(x1)">
              <p class="name">{{x1.jobName}}</p>
              <p class="money">{{x1.salary}}</p>
              <p class="info">{{x1.address+' | '+x1.workType+' | '+x1.workExperience}}</p>
            </li>
          </ul>
        </div>
        <contactCard :interactionShow="interactionShow" :complaintShow="true"></contactCard>
      </div>
    </div>
  </div>
</template>

<script>
import detailNav from '@/views/showpage/components/detailNav'
import contactCard from '@/views/showpage/components/contactcard'//联系名片组件
import comments from '@/views/showpage/components/comments'//评价表单组件
export default {
  components: { detailNav, contactCard, comments },
  data() {
    return {
      topInfo: [], // 头像下面的信息
      companyData: {
        // id: ''
      },
      setCompany: { // 企业首页的信息配置
        introduceTitleActive: 0, // 控制企业简介和视频简介的高亮
        companyHomeTitleArr: [ // 当type为公司首页时，
          {text:'企业简介',active:0},
          {text:'视频简介',active:1},
        ],
        basicInfo: [],
      },
      
      tableData: [], // 列表数据.
      commentData: [], // 评论数据
      commentInfo: [
        {label:'用户名',val:'userName'},
        {label:'分数',val:'score'},
        {label:'评论内容',val:'content'},
        {label:'评论时间',val:'createTime'},
      ], // 评论数据表头

      datainfo: [], // 数据信息
      
      jobLeftinfo: [], //  招聘  薪水下面左边的循环配置信息
      jobRightinfo: [], //  招聘  薪水下面右边的循环配置信息
      otherJob: [], // 该公司的其他职位
      pingjiaBtnArr: [
        {text:'全部',score:'all'},
        {text:'好评',score:'5'},
        {text:'中评',score:'3'},
        {text:'差评',score:'1'},
      ],
      scoreIndex: 0, // 默认给评论分类中的全部 高亮显示
      
      pageData: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      }, // 页码数据

      mapList: {
        companyhome:'企业首页',
        zhaopin:'在招职位',
        jiaoyu:'教育',
        peixun:'培训',
        rongzi:'融资',
        touzi:'投资',
        zhaoshang:'招商',
        jiameng:'加盟',
        zufang:'租房',
        shoufang:'售房',
        qiche:'汽车',
        gouwu:'电商',
        meishi:'美食',
        lvyou:'旅游',
        jiankang:'健康',
        pingjia:'用户评价',
      },
      type: '',
    }
  },
  computed: {
    routeType() { return this.$route.query.type},
    routePage() { return this.$route.query.page},
    routeOname() { return this.$route.query.oname},
    interactionShow() {
      return this.type === 'companyhome'
    }, // 右边的互动交流表单是否显示
  },
  methods: {
    rightFormSubmit(content, title) {
      console.log(title)
      let route = this.$route.name
      if (content === '') {
        this.$message.error('请填写内容后再提交！')
      } else if (['detail','detailList'].includes(route) && !this.companyData.id) {
        this.$message.warning('企业信息不完善！')
      } else if (title === '互动交流') {
        console.log('内容', content)
        // console.log(`%c公司数据:`, 'color: #00f;', this.companyData.id)
        let rD = {
          userId: this.userInfo.id,
          targetId: this.companyData.id,
          content,
        }
        this.$confirm('确定要留言此信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.util_create('hudong', rD).then(res => {
            if (res.data.status == 0) {
              this.$message.success('留言成功！')
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      } else if (title === '投诉举报') {
        // console.log('内容', content, '律师',this.layerData, '公司',this.companyData, '详情',this.detailData)
        
        let userId = this.userInfo.id
        // let areaId = this.areaIds_x[this.areaIds_x.length - 1]
        // let route = this.$route.name
        let targetId = this.companyData.id
        let subName = ''

        switch (route) {
          case 'detail':
            targetId = this.companyData.id || this.detailData.id
            subName = this.detailData.name
          break
          case 'detailList':
            targetId = this.companyData.id
            subName = this.companyData.o_name
          break
          case 'layerDetail':
            targetId = this.layerData.ownerId
            subName = this.layerData.name
          break
        }

        let rD = {
          // areaId,
          targetId,
          subName,
          userId,
          content,
        }
        console.log(rD)
        this.$confirm('确定要投诉此信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.util_create('tousu', rD).then(res => {
            if (res.data.status === 0) {
              this.$message.success('投诉成功！')
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      }
    },

    navChangeHandler(type) {
      console.log(type)
      this.tableData = []
      this.type = type

      if (this.routeOname === 'undefined') {
        this.$message.info('未能请求到企业信息！')
      }
      if (this.type === 'pingjia') {
        this.getCommentData()
      } else if (this.type !== 'companyhome') {
        this.getTableData()
      }
      this.getDataInfo()
    },

    //type为企业首页时，点击企业简介和视频简介时切换
    clickIntroduce(index) {
      this.setCompany.introduceTitleActive = index//下划线来回切换
    },
    
    //当type不为企业首页，招聘，评价时,设置数据的显示信息的配置datainfo
    getDataInfo() {
      switch(this.type) {
        case 'zhaopin'://招聘，设置的是jobleftinfo和jobrightinfo
          this.jobLeftinfo = [
            {title:'学历',shuxing:'education'},
            {title:'经验',shuxing:'workExperience'},
            {title:'人数',shuxing:'planPersons'},
            {title:'地址',shuxing:'address'},
          ]
          this.jobRightinfo = [
            {shuxing:'viewTime',suffix:'人浏览'},
            {shuxing:'createTime'}
          ]
          break;
        case 'jiaoyu'://教育
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'毕业学历',val:'educationBackGround'},
            {title:'招生性质',val:'hireProperty'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'peixun'://培训
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'招培班次',val:'trainingShifts'},
            {title:'招生性质',val:'traingingProperty'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'rongzi'://融资
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'项目状态',val:'financeStatus'},
            {title:'融资额度',val:'cash',suffix:'万元'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'touzi'://投资
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'项目情况',val:'investStatus'},
            {title:'投资额度',val:'cash',suffix:'万元'},
            {title:'所属行业',val:'belongToDomain'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'zhaoshang'://招商
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'项目情况',val:'attractInvestmentStatus'},
            {title:'所属行业',val:'belongToDomain'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'jiameng'://加盟
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'项目情况',val:'joinInStatus'},
            {title:'所属行业',val:'belongToDomain'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'zufang'://租房
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'是否合租',val:'isTogether'},
            {title:'楼层',val:'layer'},
            {title:'房型',val:'houseType'},
            {title:'装修方式',val:'renovation'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'shoufang'://售房
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'楼层',val:'layer'},
            {title:'房型',val:'houseType'},
            {title:'装修方式',val:'renovation'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'qiche'://汽车
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'售价',val:'cash',suffix:'元'},
            {title:'车龄',val:'driverAge'},
            {title:'汽车车型',val:'carType'},
            {title:'里程',val:'driverDistance',suffix:'公里'},
          ]
          break;
        case 'gouwu'://电商
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'单价',val:'price',suffix:'元'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'meishi'://美食
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'预定状态',val:'orderStatus'},
            {title:'美食类别',val:'foodType'},
            {title:'容纳人数',val:'persons',suffix:'人'},
            {title:'消费标准',val:'costStandard',suffix:'元/人'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'lvyou'://旅游
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'消费标准',val:'costStandard',suffix:'元/人'},
            {title:'行程天数',val:'tourDays',suffix:'天'},
            {title:'地址',val:'address'},
          ]
          break;
        case 'jiankang'://健康
          this.datainfo = [
            {title:'发布日期',val:'createTime'},
            {title:'浏览量',val:'viewTime',suffix:'次'},
            {title:'医疗方式',val:'medicalType'},
            {title:'医疗科别',val:'medicalCatalog'},
            {title:'地址',val:'address'},
          ]
          break;
      }
    },
    //点击数据列表
    clickData(obj) {
      if (this.routeType != 'zhaopin') {
        this.$router.push('/detail?type='+this.routeType+'&oname='+obj.o_name+'&id='+obj.id)
      } else {
        this.$router.push('/recruitDetail?type=zhaopin&id='+obj.id)
      }
    },
    clickData2(obj) {
      this.$router.push('/recruitDetail?type=zhaopin&id='+obj.id)
    },

    //筛选评价
    fifterComment(index) {
      this.scoreIndex = index
    },
    pageChange(pageNumber) {
      this.pageData.currentPage = pageNumber
      if (this.type === 'pingjia') {
        this.getCommentData()
      } else if (this.type !== 'companyhome') {
        this.getTableData()
      }
      this.$router.push('detailList?type='+this.routeType+'&page='+pageNumber+'&oname='+this.routeOname)
    },
    
    //获取企业信息
    getCompanyData() {
      let rD = { o_name: this.routeOname }
      this.$api._user_companyInfo(rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c企业:`, 'color: #f00;', _R)
          if (_R.length) {
            this.companyData = _R[0]
            
            let {
              o_domain,
              o_type,
              o_registerCash,
              o_person,
              o_name,
              o_socialCode,
              o_address,
              o_publicTime,
            } = this.companyData

            //当type为企业首页时，设置信息
            //设置企业头像下面的信息
            this.topInfo = [
              o_domain,
              o_type,
              o_registerCash,
              '员工人数:'+o_person
            ]
            this.setCompany.basicInfo = [
              {title:'企业名称：',val:o_name},
              {title:'公司信用代码：',val:o_socialCode},
              {title:'所在地区：',val:o_address,icon:'\ue601'},
              {title:'员工人数：',val:o_person+'人'},
              {title:'所属行业：',val:o_domain},
              {title:'公司性质：',val:o_type},
              {title:'成立时间：',val:o_publicTime},
              {title:'注册资金：',val:o_registerCash},
            ]
            
          } else { this.$message.warning('未能请求到企业信息！') }
        } else { this._status(res.data) }
      })
    },
    //获取列表展示数据
    getTableData() {
      let rD = {
        pageNumber: this.pageData.currentPage,
      }
      if (this.type === 'zhaopin') {
        rD.organizationName = this.routeOname
      } else {
        rD.o_name = this.routeOname
      }
      this.$api.util_search(this.type, rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c列表数据:`, 'color: #f00;', _R)
          this.tableData = _R
          this.pageData.total = res.data.size //获取该类数据的总数
        } else { this._status(res.data) }
      })
    },
    getOtherJob() {
      let rD = {
        pageNumber: 1,
        pageSize: 4,
        organizationName: this.routeOname,
      }

      this.$api.util_search('zhaopin', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c其他工作:`, 'color: #f00;', _R)
          this.otherJob = _R
        } else { this._status(res.data) }
      })
    },
    //获取评价数据
    getCommentData() {
      let rD = {
        targetId: this.companyData.id,
        pageNumber: this.pageData.currentPage,
      }
      this.scoreIndex === 0 ? '' : rD.score = parseInt(this.pingjiaBtnArr[this.scoreIndex].score)
      console.log('条件查询评论',rD)

      this.$api.util_search('pinglun', rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c评价:`, 'color: #f00;', _R)
          this.commentData = _R
          this.pageData.total = res.data.size //获取该类数据的总数
        } else { this._status(res.data) }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let { type } = to.query
      vm.type = type
      type !== 'companyhome' && type !== 'pingjia' ? vm.getTableData(): ''
      vm.getCompanyData()
      vm.getOtherJob()
      vm.getDataInfo()//设置用于显示tabledata的信息配置
    })
  },
  beforeRouteLeave(to, from, next) {
    this.companyData = {}
    next()
  }
}
</script>

<style lang='scss' scoped>
.commentBtn{
  background-color: #F56C6C;
  color: #fff;
}


.Imgbg{
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(../images/log-reg-bg.jpg) no-repeat center center;
  margin-bottom: 30px;
}
.Imgbg .headbox {
  text-align: center;
  margin: auto;
}
.Imgbg .headbox .kuang{
  width: 120px;
  height: 120px;
  margin: auto;
  padding: 15px;
  background-color: #ffffff;
}
.Imgbg .headbox img{
  width: 120px;
  height: 120px;
}
.Imgbg .headbox .name{
  font-size: 30px;
  text-align: center;
  color: #ffffff;
  width: 100%;
  padding: 20px 0;
}
.Imgbg .headbox .info{
  font-size: 14px;
  color: #ffffff;
  line-height: 28px;
  width: 100%;
  text-align: center;
}
.Imgbg .headbox .info span{
  padding: 0 5px;
}

.dataListBox{
  margin-top: 30px;
  margin-bottom: 50px;
  width: 1200px;
  border: 0px;
  justify-content: space-between;
  align-items:stretch;
  color: #666;
}

/* 除去公司首页，招聘，评价 */
.left .datalist{
  border: 1px solid #eeeeee;
  width: 850px;
}
.left .datalist .title{
  position: relative;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  padding: 0 25px;
}
.left .datalist .title::before{
  position: absolute;
  top: 16px;
  left: 16px;
  display: inline-block;
  content: "";
  width: 3px;
  height: 18px;
  background-color: red;
}
.left .datalist .dataul{
  
}
.left .datalist .dataul .datali:hover{
  cursor: pointer;
  box-shadow: 0px 0px 10px #cccccc;
}
.left .datalist .dataul .datali:hover .datainfo .dataname{
  color: #1E9FFF;
}
.left .datalist .dataul .datali{
  padding: 20px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #eee;
}
.left .datalist .dataul .datali img{
  display: block;
  width: 216px;
  height: 154px;
  margin-right: 20px;
}
.left .datalist .dataul .datali .datainfo{
  width: 570px;
  flex: 1;
}
.left .datalist .dataul .datali .datainfo .dataname{
  width: 100%;
  height: 33px;
  line-height: 33px;
  margin-bottom: 10px;
  font-size: 22px;
  color: #444;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.left .datalist .dataul .datali .datainfo .info{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.left .datalist .dataul .datali .datainfo .info .infospan{
  display: inline-block;
  width: 50%;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  color: #666;
}

.left .datalist .zhaopin .zpList{
  width: 800px;
  height: 70px;
  border-top: 1px solid #eee;
  padding: 15px 25px;
}
.left .datalist .zhaopin .zpList:hover{
  cursor: pointer;
  box-shadow: 0px 0px 10px #cccccc;
}
.left .datalist .zhaopin .zpList .listTitle{
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 5px;
}
.left .datalist .zhaopin .zpList .listTitle .jobname{
  display: inline-block;
  line-height: 18px;
  max-width: 500px;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  color: #1E9FFF;
  padding-right: 30px;
}
.left .datalist .zhaopin .zpList .listTitle .money{
  color: #e30002;
  font-size: 24px;
}
.left .datalist .zhaopin .zpList .listinfo{
  color: #999;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.left .datalist .zhaopin .zpList .listinfo .infodata{
 display: flex;
 justify-content: space-around;
}
.left .datalist .zhaopin .zpList .listinfo .infoleft{
  margin-right: 15px;
}
.left .datalist .zhaopin .zpList .listinfo .inforight{
  margin-left: 15px;
}
.left .datalist .pingjia{
  border-top: 1px solid #eee;
}
.left .datalist .pingjia .btnbox{
  padding: 20px;
  border-bottom: 1px solid #eee;
}
.left .datalist .pingjia .databox{
  padding: 20px;
}




/* 企业首页样式 */
.left .companyhome .companyIntroduce{
  border: 1px solid #eee;
  width: 850px;
}
.left .companyhome .companyIntroduce .introduceTitle{
  font-size: 18px;
  color: #333;
  line-height: 50px;
}
.left .companyhome .companyIntroduce .introduceTitle span{
  display: inline-block;
  text-align: center;
  width: 72px;
  padding: 0px 25px;
  border-right: 1px solid #eee;
}
.left .companyhome .companyIntroduce .introduceTitle span:hover{
  cursor: pointer;
  color: #1E9FFF;
}
.left .companyhome .introduceActive{
  border-bottom: 2px solid #ff6b6b;
  line-height: 48px;
}
.left .companyhome .companyIntroduce .introduceText{
  border-top: 1px solid #eee;
  padding: 25px 15px;
} 
.left .companyhome .companyIntroduce .introduceText video{
  display: block;
  height: 300px;
  margin: 0px auto;
}
.left .companyhome .basicInfo{
  margin-top: 15px;
  border: 1px solid #eee;
}
.left .companyhome .basicInfo .title{
  position: relative;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  padding: 0 25px;
}
.left .companyhome .basicInfo .title::before{
  position: absolute;
  top: 16px;
  left: 16px;
  display: inline-block;
  content: "";
  width: 3px;
  height: 18px;
  background-color: red;
}
.left .companyhome .basicInfo .infoBox{
  width: 820px;
  border-top: 1px solid #eee;
  padding: 15px;
}
.left .companyhome .basicInfo .infoBox .box{
  display: inline-block;
  width: 50%;
  height: 24px;
  line-height: 24px;
  padding: 5px 0px;
}
.left .companyhome .basicInfo .infoBox .address:hover{
  cursor: pointer;
  color: #1E9FFF;
}
.left .companyhome .basicInfo .infoBox .box i{
  margin-right: 5px;
}


.right{
  color: #666;
  width: 320px;
}

.right .otherJob{
  border: 1px solid #eee;
  margin-bottom: 15px;
}
.right .otherJob .topbox{
  display: flex;
  justify-content: space-between;
  padding: 0px 15px;
  height: 45px;
  line-height: 45px;
  background-color: #f9f9f9;
}
.right .otherJob .topbox .more{
  font-size: 14px;
  color: #999;
}
.right .otherJob .topbox .more:hover{
  cursor: pointer;
}
.right .otherJob .otherul li{
  padding: 15px;
  border-top: 1px solid #eee;
}
.right .otherJob .otherul li:hover{
  cursor: pointer;
}
.right .otherJob .otherul li:hover .name{
  color: #1E9FFF;
}
.right .otherJob .otherul li p.name{
  font-size: 16px;
  color: #444;
  margin-bottom: 5px;
}
.right .otherJob .otherul li p.money{
  font-size: 14px;
  color: #ff6b6b;
  margin-bottom: 5px;
}
.right .otherJob .otherul li p.info{
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}
.right .otherJob .otherul li p.info span{
  margin-right: 5px;
}
</style>